// ── Cart Status ──
// status 1 (DRAFT) is the patient's in-progress basket. It never surfaces on the
// bridge dashboard (not displayed or filterable there), but the verify/edit
// screen does load draft carts in EDIT-DRAFT mode, so it is defined here for the
// screen's status gating (a draft cart is still fully editable).
export const CART_STATUS_DRAFT = 1;
export const CART_STATUS_PENDING_REVIEW = 2;
export const CART_STATUS_ON_HOLD = 3;
export const CART_STATUS_REJECTED = 4;
export const CART_STATUS_SUCCESS = 5;
export const CART_STATUS_PENDING_TOPUP = 6;
export const CART_STATUS_CANCELLED = 7;

// A cart's per-service prices are frozen on its head cart_payment_request the moment it is
// approved/booked, and the backend serves them back as `serviceBreakup` (?includePrices=true).
// Those frozen prices are what the patient actually paid, so a booked cart must show them rather
// than a live re-price. Before approval (DRAFT / PENDING_REVIEW) nothing is frozen yet and the
// cart is still priced from live provider coverage, which is what the verify flow needs.
export const hasFrozenPrices = (status) =>
  status === CART_STATUS_SUCCESS || status === CART_STATUS_PENDING_TOPUP;

// ── Cart Payment Status ──
export const PAYMENT_STATUS_PENDING = 0;
export const PAYMENT_STATUS_SUCCESSFUL = 1;
export const PAYMENT_STATUS_FAILED = 2;

// ── Plan Status ──
export const PLAN_STATUS_ACTIVE = 1;
export const PLAN_STATUS_INACTIVE = 2;
export const PLAN_STATUS_UPCOMING = 3;
export const PLAN_STATUS_EXPIRED = 4;
